var map = {
	"./IMG_4902 copy.webp": 16357,
	"./IMG_4903 copy.webp": 24828,
	"./IMG_4904 copy.webp": 26711,
	"./IMG_4906 copy.webp": 45081,
	"./IMG_4908 copy.webp": 38155,
	"./IMG_4909 copy.webp": 23898,
	"./IMG_4912 copy.webp": 81366,
	"./IMG_4913 copy.webp": 28487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8989;